// extracted by mini-css-extract-plugin
export default {"root":"NZHLsZ","navigationAccessibilityHint":"ffrP7D"};